import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ContentDetailsScreen } from "../../screen/ContentDetailsScreen";

const ContentDetailsContainer = () => {
  const contentDetails = useSelector(state => state.app?.contentDetails);
  const [currentContent, setContent] = useState(null);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if(contentDetails && contentDetails.currentContent) {
      setContent(contentDetails.currentContent);
      setColumns(contentDetails.columns);
    }
  }, [contentDetails])

  return <ContentDetailsScreen
    data={currentContent}
    columns={columns}
  />
}

export default ContentDetailsContainer